// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==============================
   Page Accueil - Maquette fidele
   ============================== */

.accueil-wrapper h1 {
  font-weight: 800 !important;
}

.accueil-wrapper h2 {
  font-weight: 700 !important;
}

.accueil-wrapper {
  overflow-x: hidden;
  width: 100%;
}

/* --- Sticky Navbar --- */
.accueil-sticky-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #484848;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.28);
  display: flex;
  align-items: center;
  padding: 0 3rem;
  height: 64px;
  animation: stickyNavSlide 0.2s ease-out;
}

@keyframes stickyNavSlide {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.accueil-sticky-nav-logo {
  height: 26px;
  width: auto;
  margin-right: 2.5rem;
  flex-shrink: 0;
}

/* Liens centres en absolu sur la navbar (meme technique que la quicknav connectee).
   Le logo reste a gauche et le bloc Connexion/Inscription a droite (flux normal,
   pousse par margin-left:auto sur .accueil-sticky-nav-auth). */
.accueil-sticky-nav-links {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.accueil-sticky-nav-link {
  position: relative;
  background: none;
  border: none;
  padding: 0.5rem 1.1rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: #cdd0d0;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s;
  font-family: inherit;
}

.accueil-sticky-nav-link:hover {
  color: #ffffff;
}

/* Soulignement orange anime au survol (meme langage visuel que la navbar connectee). */
.accueil-sticky-nav-link::after {
  content: '';
  position: absolute;
  left: 1.1rem;
  right: 1.1rem;
  bottom: 0.05rem;
  height: 2px;
  border-radius: 2px;
  background: #f97316;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.2s ease;
}
.accueil-sticky-nav-link:hover::after {
  transform: scaleX(1);
}

.accueil-sticky-nav-auth {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
}

.accueil-sticky-nav-link--auth {
  font-weight: 700;
  color: #f97316;
}

.accueil-sticky-nav-link--auth:hover {
  color: #fb923c;
}

.accueil-sticky-nav-separator {
  color: #9ca3af;
  font-size: 1rem;
}

/* Hamburger button — hidden on desktop */
.accueil-sticky-nav-hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  margin-left: auto;
}

.accueil-sticky-nav-hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  background: #cdd0d0;
  border-radius: 2px;
  transition:
    transform 0.25s ease,
    opacity 0.2s ease,
    background 0.15s;
  transform-origin: center;
}

.accueil-sticky-nav-hamburger:hover span {
  background: #ffffff;
}

/* État ouvert → icône X */
.accueil-sticky-nav-hamburger--open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.accueil-sticky-nav-hamburger--open span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}
.accueil-sticky-nav-hamburger--open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Mobile dropdown menu */
.accueil-sticky-nav-mobile-menu {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  background: #3f3f3f;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.32);
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
  z-index: 999;
}

.accueil-sticky-nav-mobile-menu .accueil-sticky-nav-link {
  font-size: 1.3rem;
  padding: 1rem 1.5rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  white-space: normal;
}

.accueil-sticky-nav-mobile-auth {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 1rem 1.5rem;
}

.accueil-sticky-nav-mobile-auth .accueil-sticky-nav-link {
  border-bottom: none;
  padding: 0;
}

@media (max-width: 768px) {
  .accueil-sticky-nav {
    padding: 0 1.5rem;
  }

  .accueil-sticky-nav-links {
    display: none;
  }

  .accueil-sticky-nav-auth {
    display: none;
  }

  .accueil-sticky-nav-hamburger {
    display: flex;
  }
}

.accueil-hero-section {
  position: relative;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.accueil-hero-section::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  pointer-events: none;
}

.accueil-hero-nav {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  gap: 2.5rem;
  padding: 2.5rem 3rem;
}

.accueil-hero-nav-link {
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: opacity 0.15s;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.accueil-hero-nav-link:hover {
  opacity: 0.8;
}

.accueil-hero-bottom {
  position: relative;
  z-index: 1;
  padding: 0 3rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  width: 100%;
}

.accueil-hero-logo {
  height: 100px;
  width: auto;
}

.accueil-hero-tagline {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 800;
  margin: 0 0 2rem;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  max-width: 800px;
  line-height: 1.5;
}

.accueil-page {
  width: 100%;
  min-height: 100vh;
  background-color: #eaeff5;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 3rem;
}

/* --- Avantages Banner (orange fullscreen) --- */
.accueil-avantages-banner {
  width: 100%;
  background-color: #f97316;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 0;
  padding: 3.5rem 8rem;
}

.accueil-avantage-banner-item {
  flex: 1 1 200px;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.2rem 1.5rem;
  color: #ffffff;
  justify-content: flex-start;
}

.accueil-avantage-banner-icon {
  width: 72px;
  height: 72px;
  object-fit: contain;
  display: block;
}

.accueil-avantage-banner-icon-wrap {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.2rem;
}

.accueil-avantage-banner-icon--small {
  width: 62px;
  height: 62px;
}

.accueil-avantage-banner-item h4 {
  font-size: 1.1rem !important;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin: 0 0 0.5rem;
  color: #ffffff;
  text-transform: uppercase;
}

.accueil-avantage-banner-item p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
}

@media (max-width: 1024px) {
  .accueil-avantages-banner {
    padding: 2.5rem 4rem;
  }
  .accueil-avantage-banner-item {
    flex: 1 1 160px;
    max-width: 200px;
  }
  .accueil-avantage-banner-item h4 {
    font-size: 1.15rem;
  }
  .accueil-avantage-banner-item p {
    font-size: 1.05rem;
  }
}

@media (max-width: 768px) {
  .accueil-avantages-banner {
    padding: 4rem 1.5rem;
    gap: 0.75rem;
    justify-content: center;
  }
  .accueil-avantage-banner-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.75rem);
    max-width: calc(50% - 0.75rem);
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .accueil-hero-nav {
    padding: 2rem 1.5rem;
    gap: 1.5rem;
  }
  .accueil-hero-nav-link {
    font-size: 1.2rem;
  }
  .accueil-hero-logo {
    height: 70px;
  }
  .accueil-hero-tagline {
    font-size: 1.2rem;
  }
  .accueil-hero-bottom {
    padding: 0 1.5rem 3rem;
  }
}

@media (max-width: 480px) {
  .accueil-avantages-banner {
    padding: 3.5rem 1rem;
    gap: 0.5rem;
  }
  .accueil-avantage-banner-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 0.75rem 0.5rem;
  }
  .accueil-avantage-banner-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    margin-bottom: 0.6rem;
  }
  .accueil-avantage-banner-item h4 {
    font-size: 1.25rem;
    margin-bottom: 0.3rem;
  }
  .accueil-avantage-banner-item p {
    font-size: 1.15rem;
  }
}

/* --- Header / Hero --- */
.accueil-header {
  background-color: #ffffff;
  text-align: center;
  padding: 48px 40px 5rem;
  width: 100%;
}

.accueil-title {
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  font-size: 3.5rem;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.3;
  margin: 0 0 22px;
}

.accueil-subtitle {
  font-size: 1.5rem;
  color: #666666;
  margin: 3px 0;
  /* line-height: 1.5; */
  font-weight: 400;
}

/* --- Section Qui sommes-nous --- */
.accueil-about {
  display: flex;
  align-items: stretch;
  /* padding: 36px 60px 60px; */
  max-width: 1280px;
  margin: 0 auto;
  /* width: 90%; */
  flex: 1 1;
  background-color: #fff;
}

.accueil-about-image {
  flex: 0 0 35%;
  overflow: hidden;
}

.accueil-about-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

.accueil-about-text {
  flex: 1 1;
  padding: 4rem 5rem;
}

.accueil-about-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 20px;
  line-height: 1.2;
  text-align: center;
}

.accueil-qui {
  color: #f97316;
  font-weight: 800;
}

.accueil-about-text p:first-of-type {
  margin-top: 4rem;
}

.accueil-about-text p {
  font-size: 1.5rem;
  color: #374151;
  line-height: 1.8;
  margin: 0 0 16px;
  text-align: justify;
}

.accueil-about-text p strong {
  font-weight: 700;
}

.accueil-link {
  color: #f97316;
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
}

.accueil-link:hover {
  text-decoration: underline;
}

/* --- Section Mutualisation --- */
.accueil-mutualisation {
  background-color: #2c3948;
  display: flex;
  align-items: stretch;
}

.accueil-mutualisation-content {
  flex: 1 1;
  padding: 40px 48px;
  color: #ffffff;
}

.accueil-mutualisation-title {
  font-size: 3rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 20px;
  line-height: 1.3;
  text-align: center;
}

.accueil-mutualisation-title strong {
  font-weight: 700;
}

.accueil-mutualisation-quote {
  font-size: 1.4rem;
  font-style: italic;
  color: #fff;
  line-height: 1.7;
  margin: 0;
  font-weight: 600;
  text-align: justify;
}

.accueil-mutualisation-image {
  flex: 0 0 50%;
  overflow: hidden;
}

.accueil-mutualisation-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

/* --- Section Avantages --- */
.accueil-avantages {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 40px 48px;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
}

.accueil-highlight {
  color: #f97316;
  font-weight: 800 !important;
}

.accueil-section-block {
  max-width: 1280px;
  margin: 0 auto;
  width: 90%;
}

.accueil-section-block:last-of-type {
  margin-bottom: 5rem;
}

.accueil-avantage {
  flex: 1 1;
  text-align: center;
  padding: 0 8px;
}

.accueil-avantage-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
}

.accueil-avantage-icon svg {
  width: 100%;
  height: 100%;
}

.accueil-avantage-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #f97316;
  text-transform: uppercase;
  margin: 0 0 8px;
  letter-spacing: 0.3px;
}

.accueil-avantage p {
  font-size: 1.35rem;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

/* --- Section Catalogue --- */
.accueil-catalogue {
  background-color: #fff;
}

.accueil-catalogue-top {
  display: flex;
  align-items: stretch;
}

.accueil-catalogue-image {
  flex: 0 0 20%;
  overflow: hidden;
}

.accueil-catalogue-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

.accueil-catalogue-lots {
  flex: 1 1;
  padding: 40px 48px;
  color: #ffffff;
}

.accueil-catalogue-title {
  font-size: 3rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 28px;
  line-height: 1.3;
  text-align: center;
}

.accueil-lots-grid {
  display: flex;
  gap: 40px;
  margin-top: 4rem;
}

.accueil-lots-col {
  flex: 1 1;
}

.accueil-lots-col p {
  font-size: 1.35rem;
  color: #2c3948;
  margin: 0 0 6px;
  line-height: 1.5;
}

/* --- Section Catalogues Description --- */
.accueil-catalogues-desc {
  padding: 5rem 0 0;
  background-color: #ffffff;
}

.accueil-catalogues-desc p {
  font-size: 1.45rem;
  color: #374151;
  line-height: 1.7;
  margin: 0 0 18px;
}

.accueil-catalogues-desc p strong {
  font-weight: 700;
  /* text-decoration: underline; */
}

/* --- Section Entreprises performantes --- */
.accueil-entreprises {
  display: flex;
  align-items: stretch;
  background-color: #f97316;
}

.accueil-entreprises-content {
  flex: 1 1;
  padding: 40px 48px;
  color: #ffffff;
}

.accueil-entreprises-title {
  font-size: 3rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 18px;
  line-height: 1.3;
  text-align: center;
}

.accueil-entreprises-title strong {
  font-weight: 800;
}

.accueil-entreprises-content p {
  font-size: 1.45rem;
  color: #ffffff;
  line-height: 1.7;
  margin: 0 0 14px;
}

.accueil-entreprises-note {
  font-size: 1.5rem !important;
  font-style: italic;
  opacity: 0.9;
}

.accueil-entreprises-image {
  flex: 0 0 40%;
  overflow: hidden;
}

.accueil-entreprises-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

/* --- Section Fonctionnement simple --- */
.accueil-fonctionnement {
  /* padding: 48px 48px 0; */
  background-color: #ffffff;
  display: flex;
}

.accueil-fonctionnement-title {
  font-size: 2rem;
  font-weight: 700;
  color: #f97316;
  text-align: center;
  margin: 0 0 3rem;
}

.accueil-fonctionnement-title em {
  /* font-style: italic; */
  font-weight: 800;
}

.accueil-fonctionnement-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 5rem;
}

.accueil-fonctionnement-grid {
  flex: 1 1;
  display: flex;
  border: 1px solid #e5e7eb;
}

.accueil-fonctionnement-col {
  flex: 1 1;
  border-right: 1px solid #e5e7eb;
}

.accueil-fonctionnement-col:last-child {
  border-right: none;
}

.accueil-fonctionnement-header {
  background-color: #f97316;
  padding: 14px 16px;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
}

.accueil-fonctionnement-num {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 2px;
}

.accueil-fonctionnement-label {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.accueil-fonctionnement-body {
  padding: 16px;
}

.accueil-fonctionnement-body p {
  font-size: 1.35rem;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 12px;
}

.accueil-fonctionnement-body p strong {
  font-weight: 800;
}

.accueil-fonctionnement-image {
  flex: 0 0 20%;
  overflow: hidden;
}

.accueil-fonctionnement-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

/* --- Section Délai d'exécution --- */
.accueil-delai {
  display: flex;
  align-items: stretch;
  background-color: #484848;
}

.accueil-delai-image {
  flex: 0 0 30%;
  overflow: hidden;
}

.accueil-delai-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

.accueil-delai-content {
  flex: 1 1;
  padding: 40px 48px;
  text-align: center;
  color: #ffffff;
}

.accueil-delai-title {
  font-size: 3rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 20px;
}

.accueil-delai-title em {
  font-weight: 800;
}

.accueil-delai-formula {
  font-size: 1.35rem;
  line-height: 1.6;
  margin: 0 0 20px;
}

.accueil-delai-example {
  font-size: 1.4rem;
  margin: 0 0 8px;
}

.accueil-delai-result {
  font-size: 2rem;
  font-weight: 800;
  margin: 0 0 20px;
}

.accueil-delai-note {
  font-size: 1.35rem;
  font-style: italic;
  opacity: 0.9;
}

/* --- Section Gratuit et sans engagement --- */
.accueil-gratuit {
  display: flex;
  align-items: stretch;
}

.accueil-gratuit-image {
  flex: 0 0 20%;
  overflow: hidden;
}

.accueil-gratuit-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #d1d5db;
}

.accueil-gratuit-content {
  flex: 1 1;
  padding: 40px 48px;
  background-color: #f97316;
  color: #ffffff;
}

.accueil-gratuit-title {
  font-size: 3rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px;
  text-align: center;
}

.accueil-gratuit-title strong {
  font-weight: 700;
}

.accueil-gratuit-price {
  font-size: 3.5rem;
  font-weight: 700;
  text-align: center;
  margin: 0 0 2.5rem;
}

.accueil-gratuit-content p {
  /* font-size: 14px; */
  color: #ffffff;
  line-height: 1.7;
  margin: 0 0 14px;
}

.accueil-gratuit-content p strong {
  font-weight: 700;
  /* text-decoration: underline; */
}

.accueil-gratuit-options {
  display: flex;
  /* gap: 16px; */
  margin-top: 20px;
  border: 2px solid #ffffff;
}

.accueil-gratuit-option {
  flex: 1 1;
}

.accueil-gratuit-option:not(:last-child) {
  border-right: 2px solid #ffffff;
}

.accueil-gratuit-option-header {
  background-color: #484848;
  color: #ffffff;
  font-size: 2rem;
  font-weight: 800;
  text-align: center;
  padding: 12px 16px;
  line-height: 1.4;
  border-bottom: 2px solid #ffffff;
}

.accueil-gratuit-option-body {
  padding: 16px;
}

.accueil-gratuit-option-body p {
  font-size: 1.35rem;
  /* font-style: italic; */
  line-height: 1.6;
  margin: 0 0 10px;
}

/* --- Section On parle de nous --- */
.accueil-presse {
  padding: 48px 60px;
  background-color: #ffffff;
}

.accueil-presse-title {
  font-size: 3rem;
  font-weight: 700;
  color: #f97316;
  text-align: center;
  margin: 0 0 36px;
}

.accueil-presse-title strong {
  font-weight: 700;
  color: #f97316;
}

.accueil-presse-list {
  max-width: 800px;
  margin: 0 auto;
}

.accueil-presse-item {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 20px 0;
  border-bottom: 1px solid #e5e7eb;
}

.accueil-presse-item:last-child {
  border-bottom: none;
}

.accueil-presse-logo {
  flex: 0 0 120px;
}

.accueil-presse-logo img {
  max-width: 100%;
  height: auto;
  display: block;
  background-color: #e5e7eb;
  min-height: 40px;
}

.accueil-presse-text p {
  font-size: 1.45rem;
  color: #374151;
  margin: 0 0 4px;
  line-height: 1.5;
}

/* --- Responsive --- */
@media (max-width: 960px) {
  .accueil-about {
    flex-direction: column;
    padding: 24px 24px 40px;
  }

  .accueil-about-image {
    flex: none;
    width: 100%;
  }

  .accueil-about-image img {
    height: 260px;
  }

  .accueil-header {
    padding: 32px 20px 28px;
  }

  .accueil-title {
    font-size: 2rem;
  }

  .accueil-mutualisation {
    flex-direction: column;
  }

  .accueil-mutualisation-image {
    flex: none;
    height: 200px;
  }

  .accueil-avantages {
    flex-wrap: wrap;
    gap: 24px;
    padding: 32px 24px;
  }

  .accueil-avantage {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 12px);
  }

  .accueil-catalogue-top {
    flex-direction: column;
  }

  .accueil-catalogue-image {
    flex: none;
    height: 200px;
  }

  .accueil-lots-grid {
    flex-direction: column;
    gap: 16px;
  }

  .accueil-catalogues-desc {
    padding: 24px 24px;
  }

  .accueil-entreprises {
    flex-direction: column;
  }

  .accueil-entreprises-image {
    flex: none;
    height: 200px;
  }

  .accueil-fonctionnement {
    padding: 32px 16px 0;
  }

  .accueil-fonctionnement-row {
    flex-direction: column;
  }

  .accueil-fonctionnement-grid {
    flex-direction: column;
  }

  .accueil-fonctionnement-col {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .accueil-fonctionnement-image {
    flex: none;
    height: 200px;
  }

  .accueil-delai {
    flex-direction: column;
  }

  .accueil-delai-image {
    flex: none;
    height: 200px;
  }

  .accueil-gratuit {
    flex-direction: column;
  }

  .accueil-gratuit-image {
    flex: none;
    height: 200px;
  }

  .accueil-gratuit-options {
    flex-direction: column;
  }

  .accueil-presse {
    padding: 32px 24px;
  }

  .accueil-presse-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

/* ==============================
   Bannière acheteurs (logos + compteur)
   ============================== */

.accueil-acheteurs-banner {
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 7rem 8rem;
  display: flex;
  align-items: center;
  gap: 3rem;
  overflow: hidden;
}

@keyframes accueil-logos-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.accueil-acheteurs-logos {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.accueil-logos-track {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2.5rem;
  width: max-content;
  animation: accueil-logos-scroll 50s linear infinite;
}

#section-acheteurs .accueil-logos-track {
  animation-duration: 70s;
}

.accueil-acheteur-logo-placeholder {
  aspect-ratio: 3 / 2;
  min-width: 110px;
  height: 76px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  padding: 0 0.3rem;
  word-break: break-word;
  overflow: hidden;
  flex-shrink: 0;
}

.accueil-acheteur-logo-placeholder:hover {
  background: transparent;
}

.accueil-prestataire-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  /* Anti pop-in : opacite 0 par defaut, fade-in declenche au CHARGEMENT reel de
     l'image (classe .is-loaded posee par onLoad). L'espace est deja reserve par
     .accueil-acheteur-logo-placeholder, donc aucun layout shift. */
  opacity: 0;
  transition: opacity 0.4s ease;
}

.accueil-prestataire-logo-img.is-loaded {
  opacity: 1;
}

.accueil-prestataire-logo-fallback {
  display: none;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  padding: 0 0.3rem;
  word-break: break-word;
  color: #9ca3af;
}

.accueil-acheteurs-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
}

.accueil-acheteurs-number {
  font-size: 4rem;
  font-weight: 800;
  color: #f97316;
  line-height: 1;
}

.accueil-acheteurs-label {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  line-height: 1;
}

.accueil-acheteurs-link {
  font-size: 1.1rem !important;
  font-weight: 700;
}

@media (max-width: 900px) {
  .accueil-acheteurs-logos {
    overflow: hidden;
  }
  .accueil-logos-track {
    animation-duration: 35s;
  }
  #section-acheteurs .accueil-logos-track {
    animation-duration: 50s;
  }
  .accueil-acheteur-logo-placeholder {
    flex: none;
    min-width: 90px;
    height: 65px;
    aspect-ratio: 3 / 2;
    font-size: 0.8rem;
  }
  .accueil-acheteurs-info {
    flex: none;
    width: 100%;
    align-items: center;
    margin-top: 2rem;
  }
  .accueil-acheteurs-banner {
    flex-direction: column;
    padding: 4rem 1.5rem;
    gap: 1.5rem;
  }
}

@media (max-width: 640px) {
  .accueil-acheteurs-logos {
    overflow: hidden;
  }
  .accueil-logos-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: max-content;
    gap: 1.5rem;
    animation: accueil-logos-scroll 30s linear infinite;
  }
  #section-acheteurs .accueil-logos-track {
    animation-duration: 40s;
  }
  .accueil-acheteur-logo-placeholder {
    min-width: 80px;
    height: 55px;
    width: auto;
    flex-shrink: 0;
    aspect-ratio: 3 / 2;
  }
  #section-acheteurs .accueil-logos-track > *:nth-child(n + 23) {
    display: flex;
  }
  #section-prestataires .accueil-logos-track > *:nth-child(n + 16) {
    display: flex;
  }
}

@media (max-width: 480px) {
  .accueil-acheteurs-logos {
    gap: 0.4rem;
  }
}

/* ==============================
   Section fonctionnement acheteurs
   ============================== */

.accueil-fonctact-section {
  background: #f3f4f6;
  display: flex;
  align-items: stretch;
}

.accueil-fonctact-text {
  flex: 1 1;
  padding: 7rem 6rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  max-height: 520px;
  overflow-y: auto;
}

.accueil-fonctact-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 0.5rem;
  line-height: 1.25;
}

.accueil-fonctact-text p {
  font-size: 1.2rem;
  color: #1f2937;
  line-height: 1.8;
  margin: 0;
}

.accueil-fonctact-text p strong {
  font-weight: 700;
}

.accueil-voir-suite {
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #f97316;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: opacity 0.15s;
}

.accueil-voir-suite--reduire {
  margin-top: 0.25rem;
}

.accueil-voir-suite:hover {
  opacity: 0.75;
}

.accueil-fonctact-steps {
  margin: 0;
  padding-left: 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.accueil-fonctact-steps li {
  font-size: 1.2rem;
  color: #1f2937;
  line-height: 1.75;
}

.accueil-fonctact-steps li strong {
  font-weight: 700;
  color: #111827;
}

.accueil-fonctact-cta {
  margin-top: 0.5rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.accueil-fonctact-image {
  flex: 0 0 50%;
  overflow: hidden;
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 520px;
}

.accueil-fonctact-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (max-width: 960px) {
  .accueil-fonctact-section {
    flex-direction: column;
  }
  .accueil-fonctact-image {
    flex: none;
    height: 280px;
    order: -1;
    position: static;
    align-self: auto;
  }
  .accueil-fonctact-text {
    padding: 4rem 2rem;
    max-height: none;
    overflow-y: visible;
  }
  .accueil-fonctact-section--reversed .accueil-fonctact-text {
    padding: 4rem 2rem;
  }
}

/* Variante prestataires : image à gauche */
.accueil-fonctact-section--reversed .accueil-fonctact-text {
  padding: 4rem 6rem 4rem 4rem;
}

@media (max-width: 960px) {
  .accueil-fonctact-section--reversed .accueil-fonctact-image {
    order: -1;
  }
}

/* ==============================
   Mosaïque des lots techniques
   ============================== */

.accueil-lots-mosaic-section {
  background: #f9fafb;
  padding: 7rem 8rem;
}

.accueil-lots-mosaic-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.accueil-lots-mosaic-header h2 {
  font-size: 2.5rem;
  color: #f97316;
  margin-bottom: 0.5rem;
}

.accueil-lots-mosaic-header p {
  font-size: 1.1rem;
  color: #6b7280;
}

.accueil-lots-mosaic {
  display: grid;
  /* Toujours 4 colonnes, mais qui occupent toute la largeur utile : on retire le plafond
     \`max-width: 1400px; margin: 0 auto\` qui centrait la grille et laissait de grosses marges sur
     grand ecran. Les cartes s'elargissent pour remplir la place ; leur ratio 4/3 preserve la hauteur. */
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.accueil-lot-card {
  display: flex;
  flex-direction: column;
  aspect-ratio: 4 / 3;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}

.accueil-lot-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
}

.accueil-lot-card:hover .accueil-lot-card-body {
  background: #f97316;
}

.accueil-lot-card:hover .accueil-lot-card-code,
.accueil-lot-card:hover .accueil-lot-card-nom {
  color: #ffffff;
}

.accueil-lot-card:focus {
  outline: 3px solid #f97316;
  outline-offset: 2px;
}

.accueil-lot-card-img-wrap {
  flex: 3 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.accueil-lot-card-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  z-index: 2;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.accueil-lot-card-badge--ingenierie {
  background-color: #6b7280;
}
.accueil-lot-card-badge--travaux {
  background-color: #f97316;
}
.accueil-lot-card-badge--services {
  background-color: #6b7280;
}

.accueil-lot-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.accueil-lot-card-body {
  flex: 1 1;
  min-height: 0;
  padding: 0.55rem 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 0.15rem;
  background: #ffffff;
  border-top: 1px solid #f3f4f6;
  transition: background 0.2s;
}

.accueil-lot-card-code {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.accueil-lot-card-nom {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

/* Skeleton de chargement des lots (evite le flash "4 puis le reste") */

.accueil-lot-card--skeleton {
  cursor: default;
  pointer-events: none;
}

.accueil-skeleton-shimmer,
.accueil-skeleton-line {
  background: linear-gradient(
    90deg,
    #eceff1 25%,
    #f5f7f8 37%,
    #eceff1 63%
  );
  background-size: 400% 100%;
  animation: accueil-skeleton-pulse 1.4s ease infinite;
}

.accueil-skeleton-shimmer {
  width: 100%;
  height: 100%;
}

.accueil-skeleton-line {
  display: block;
  border-radius: 4px;
  height: 0.8rem;
}

.accueil-skeleton-line--code {
  width: 30%;
  height: 0.7rem;
}

.accueil-skeleton-line--nom {
  width: 70%;
}

@keyframes accueil-skeleton-pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* Articles dans la modale lot */

.accueil-lot-articles {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.accueil-lot-articles .modal-articles-search {
  padding: 1rem 2rem 1rem;
  flex-shrink: 0;
}

.accueil-lot-articles .modal-articles-content {
  flex: 1 1;
  overflow-y: auto;
}

.accueil-lot-articles .article-row--public {
  grid-template-columns: 90px 1fr;
}

/* Prompt connexion — overlay centré identique à Annuaire */
.accueil-article-prompt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 1rem;
}

.accueil-article-prompt-card {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 2rem 2rem;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.accueil-article-prompt-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1rem;
  color: #9ca3af;
  cursor: pointer;
  line-height: 1;
  padding: 0.2rem 0.4rem;
}

.accueil-article-prompt-close:hover {
  color: #374151;
}

.accueil-article-prompt-title {
  font-size: 1.65rem;
  font-weight: 700;
  color: #f97316;
  margin-bottom: 0.85rem;
}

.accueil-article-prompt-text {
  font-size: 1.2rem;
  color: #6b7280;
  line-height: 1.65;
  margin-bottom: 1.75rem;
}

.accueil-article-prompt-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Responsive mosaïque */

@media (max-width: 1200px) {
  .accueil-lots-mosaic {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .accueil-lots-mosaic {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .accueil-lots-mosaic-header h2 {
    font-size: 2.5rem;
  }

  .accueil-lots-mosaic-section {
    padding: 5rem 1rem;
  }
}

@media (max-width: 480px) {
  .accueil-lots-mosaic {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .accueil-lots-mosaic-section {
    padding: 4rem 0.75rem;
  }
}

/* ==============================
   Section Témoignages
   ============================== */

.accueil-temoignages-section {
  background: #ffffff;
  padding: 7rem 8rem;
}

.accueil-temoignages-header {
  text-align: center;
  margin-bottom: 3rem;
}

.accueil-temoignages-header h2 {
  font-size: 2.5rem;
  color: #f97316;
  font-weight: 700;
}

/* Testimonials: grid responsive */
.accueil-temoignages-grid-wrapper {
  width: 100%;
}

.accueil-temoignages-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
  width: 100%;
}

.accueil-temoignage-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.accueil-temoignage-quote-icon {
  font-size: 3.5rem;
  color: #f97316;
  line-height: 1;
  font-family: Georgia, serif;
  font-weight: 700;
}

.accueil-temoignage-text {
  font-size: 1.1rem;
  color: #4b5563;
  line-height: 1.7;
  font-style: italic;
  flex: 1 1;
}

.accueil-temoignage-author {
  font-size: 1.15rem;
  font-weight: 700;
  color: #374151;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

@media (max-width: 960px) {
  .accueil-temoignages-section {
    padding: 5rem 3rem;
  }
}

@media (max-width: 640px) {
  .accueil-temoignages-section {
    padding: 4rem 1.5rem;
  }

  .accueil-temoignages-grid-wrapper {
    overflow-x: unset;
  }

  .accueil-temoignages-grid {
    grid-template-columns: 1fr;
  }

  .accueil-temoignage-card {
    min-width: unset;
  }

  .accueil-avantages {
    flex-direction: column;
    padding: 2.5rem 1.5rem;
    gap: 2rem;
  }

  .accueil-avantage-title {
    font-size: 1.4rem;
  }

  .accueil-avantage p {
    font-size: 1.25rem;
  }
}

/* ==============================
   Section Qui sommes-nous
   ============================== */

.accueil-quisommes-section {
  background: #ffffff;
  display: flex;
  align-items: stretch;
  padding: 0;
}

.accueil-quisommes-image {
  flex: 0 0 45%;
  overflow: hidden;
}

.accueil-quisommes-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.accueil-quisommes-text {
  flex: 1 1;
  padding: 7rem 6rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  justify-content: center;
  background: #f3f4f6;
}

.accueil-quisommes-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: #f97316;
  margin: 0 0 0.5rem;
  line-height: 1.25;
}

.accueil-quisommes-text p {
  font-size: 1.1rem;
  color: #374151;
  line-height: 1.8;
  margin: 0;
}

.accueil-quisommes-cta {
  margin-top: 0.5rem;
}

@media (max-width: 960px) {
  .accueil-quisommes-section {
    flex-direction: column;
  }

  .accueil-quisommes-image {
    flex: none;
    height: 300px;
  }

  .accueil-quisommes-text {
    padding: 4rem 2rem;
  }
}

@media (max-width: 640px) {
  .accueil-quisommes-title {
    font-size: 2.8rem;
  }
  .accueil-quisommes-text p {
    font-size: 1.45rem;
  }
}

/* ==============================
   Modale vidéo YouTube
   ============================== */

.accueil-video-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.accueil-video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.accueil-modal--page-content {
  width: 90vw;
  max-width: 960px;
  height: 85dvh;
}

/* ==============================
   Section Presse
   ============================== */

.accueil-presse-section {
  background: #ffffff;
  padding: 7rem 8rem;
}

.accueil-presse-section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #f97316;
  text-align: center;
  margin: 0 0 3rem;
}

.accueil-presse-section-title strong {
  font-weight: 700;
}

.accueil-presse-section-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 900px;
  margin: 0 auto;
  gap: 2rem;
}

.accueil-presse-section-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
}

.accueil-presse-section-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

.accueil-presse-section-logo-wrap {
  height: 140px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.accueil-presse-section-logo-wrap img {
  max-width: 100%;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.accueil-presse-section-body {
  padding: 1.25rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 0.75rem;
  background: #f3f4f6;
}

.accueil-presse-section-body p {
  font-size: 1.15rem;
  color: #374151;
  line-height: 1.6;
  font-style: italic;
  margin: 0;
  flex: 1 1;
}

.accueil-presse-section-body a {
  font-size: 1.1rem;
  font-weight: 600;
  color: #f97316;
  text-decoration: none;
}

.accueil-presse-section-body a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .accueil-presse-section {
    padding: 5rem 2rem;
  }

  .accueil-presse-section-list {
    grid-template-columns: 1fr;
    max-width: 320px;
  }
}

@media (max-width: 480px) {
  .accueil-presse-section {
    padding: 4rem 1.5rem;
  }
}

/* ==============================
   Footer
   ============================== */

.accueil-footer {
  background-color: #2c3948;
  padding: 3rem 8rem 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
}

.accueil-footer-left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

.accueil-footer-logo {
  height: 44px;
  width: auto;
  display: block;
  opacity: 0.9;
  margin-left: -2px;
}

.accueil-footer-links {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem 2rem;
  margin-top: 1rem;
}

.accueil-footer-links-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 2rem;
  align-items: center;
}

.accueil-footer-link {
  color: #94a3b8;
  font-size: 1.35rem;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.15s;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
}

.accueil-footer-btn {
  align-self: center;
}

.accueil-footer-link:hover {
  color: #ffffff;
}

@media (max-width: 960px) {
  .accueil-footer {
    padding: 2.5rem 3rem 2rem;
  }
}

@media (max-width: 640px) {
  .accueil-footer {
    padding: 2rem 1.5rem 1.75rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.75rem;
  }

  .accueil-footer-logo {
    height: 36px;
  }

  .accueil-footer-left {
    gap: 1.25rem;
  }

  .accueil-footer-links {
    gap: 0.5rem 1.5rem;
  }

  .accueil-footer-links-row {
    display: contents;
  }

  .accueil-footer-link {
    font-size: 1.1rem;
  }

  .accueil-footer-btn {
    align-self: flex-start !important;
    margin-right: auto;
  }
}

/* ==============================
   Upscale typographie — grand écran
   ============================== */

@media (min-width: 1024px) {
  /* Navigation */
  .accueil-sticky-nav-link {
    font-size: 1.35rem;
  }

  /* Hero */
  .accueil-title {
    font-size: 4.2rem;
  }
  .accueil-subtitle {
    font-size: 1.8rem;
  }

  /* À propos (section haut de page) */
  .accueil-about-title {
    font-size: 4.2rem;
  }
  .accueil-about-text p {
    font-size: 1.75rem;
  }

  /* Mutualisation */
  .accueil-mutualisation-title {
    font-size: 3.6rem;
  }
  .accueil-mutualisation-quote {
    font-size: 1.65rem;
  }

  /* Avantages */
  .accueil-avantage-title {
    font-size: 1.55rem;
  }
  .accueil-avantage p {
    font-size: 1.6rem;
  }

  /* Fonctionnement simple (tableau) */
  .accueil-fonctionnement-title {
    font-size: 2.5rem;
  }
  .accueil-fonctionnement-num {
    font-size: 18px;
  }
  .accueil-fonctionnement-label {
    font-size: 18px;
  }
  .accueil-fonctionnement-body p {
    font-size: 1.6rem;
  }

  /* Catalogue */
  .accueil-catalogue-title {
    font-size: 3.6rem;
  }
  .accueil-lots-col p {
    font-size: 1.6rem;
  }
  .accueil-catalogues-desc p {
    font-size: 1.75rem;
  }

  /* Entreprises performantes */
  .accueil-entreprises-title {
    font-size: 3.6rem;
  }
  .accueil-entreprises-content p {
    font-size: 1.75rem;
  }
  .accueil-entreprises-note {
    font-size: 1.8rem !important;
  }

  /* Délai d'exécution */
  .accueil-delai-title {
    font-size: 3.6rem;
  }
  .accueil-delai-formula {
    font-size: 1.6rem;
  }
  .accueil-delai-example {
    font-size: 1.65rem;
  }
  .accueil-delai-result {
    font-size: 2.4rem;
  }
  .accueil-delai-note {
    font-size: 1.6rem;
  }

  /* Gratuit et sans engagement */
  .accueil-gratuit-title {
    font-size: 3.6rem;
  }
  .accueil-gratuit-price {
    font-size: 4.2rem;
  }
  .accueil-gratuit-option-header {
    font-size: 2.4rem;
  }
  .accueil-gratuit-option-body p {
    font-size: 1.6rem;
  }

  /* Bannière acheteurs (compteur) */
  .accueil-acheteurs-number {
    font-size: 5rem;
  }
  .accueil-acheteurs-label {
    font-size: 1.6rem;
  }
  .accueil-acheteurs-link {
    font-size: 1.3rem !important;
  }

  /* Fonctionnement acheteurs / prestataires */
  .accueil-fonctact-title {
    font-size: 3.4rem;
  }
  .accueil-fonctact-text p {
    font-size: 1.45rem;
  }
  .accueil-fonctact-steps li {
    font-size: 1.45rem;
  }

  /* Mosaïque des lots */
  .accueil-lots-mosaic-header h2 {
    font-size: 2.5rem;
  }
  .accueil-lots-mosaic-header p {
    font-size: 1.35rem;
  }
  .accueil-lot-card-badge {
    font-size: 1.25rem;
  }
  .accueil-lot-card-code {
    font-size: 1.3rem;
  }
  .accueil-lot-card-nom {
    font-size: 1.5rem;
  }

  /* Témoignages */
  .accueil-temoignages-header h2 {
    font-size: 2.5rem;
  }
  .accueil-temoignage-text {
    font-size: 1.3rem;
  }
  .accueil-temoignage-author {
    font-size: 1.4rem;
  }

  /* Qui sommes-nous */
  .accueil-quisommes-title {
    font-size: 3.4rem;
  }
  .accueil-quisommes-text p {
    font-size: 1.35rem;
  }

  /* Centralis dans les médias */
  .accueil-presse-section-title {
    font-size: 2.5rem;
  }
  .accueil-presse-section-body p {
    font-size: 1.4rem;
  }
  .accueil-presse-section-body a {
    font-size: 1.3rem;
  }

  /* Bannière avantages (fond orange) */
  .accueil-avantage-banner-item h4 {
    font-size: 1.3rem !important;
  }
  .accueil-avantage-banner-item p {
    font-size: 1.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Accueil/Accueil.css"],"names":[],"mappings":"AAAA;;mCAEmC;;AAEnC;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;oBAGkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd;;mEAEiE;EACjE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,mDAAmD;EACrD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb;;wGAEsG;EACtG,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC;;mBAEiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uEAAuE;;AAEvE;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE;;;;;GAKC;EACD,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;;mCAEmC;;AAEnC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;;kBAEgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;EACpB;AACF;;AAEA;;mCAEmC;;AAEnC;EACE,eAAe;EACf;IACE,kBAAkB;EACpB;;EAEA,SAAS;EACT;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;EAEA,cAAc;EACd;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;;EAEA,4CAA4C;EAC5C;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA,8BAA8B;EAC9B;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ==============================\n   Page Accueil - Maquette fidele\n   ============================== */\n\n.accueil-wrapper h1 {\n  font-weight: 800 !important;\n}\n\n.accueil-wrapper h2 {\n  font-weight: 700 !important;\n}\n\n.accueil-wrapper {\n  overflow-x: hidden;\n  width: 100%;\n}\n\n/* --- Sticky Navbar --- */\n.accueil-sticky-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: #484848;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.28);\n  display: flex;\n  align-items: center;\n  padding: 0 3rem;\n  height: 64px;\n  animation: stickyNavSlide 0.2s ease-out;\n}\n\n@keyframes stickyNavSlide {\n  from {\n    transform: translateY(-100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n.accueil-sticky-nav-logo {\n  height: 26px;\n  width: auto;\n  margin-right: 2.5rem;\n  flex-shrink: 0;\n}\n\n/* Liens centres en absolu sur la navbar (meme technique que la quicknav connectee).\n   Le logo reste a gauche et le bloc Connexion/Inscription a droite (flux normal,\n   pousse par margin-left:auto sur .accueil-sticky-nav-auth). */\n.accueil-sticky-nav-links {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.accueil-sticky-nav-link {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 0.5rem 1.1rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #cdd0d0;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s;\n  font-family: inherit;\n}\n\n.accueil-sticky-nav-link:hover {\n  color: #ffffff;\n}\n\n/* Soulignement orange anime au survol (meme langage visuel que la navbar connectee). */\n.accueil-sticky-nav-link::after {\n  content: '';\n  position: absolute;\n  left: 1.1rem;\n  right: 1.1rem;\n  bottom: 0.05rem;\n  height: 2px;\n  border-radius: 2px;\n  background: #f97316;\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: transform 0.2s ease;\n}\n.accueil-sticky-nav-link:hover::after {\n  transform: scaleX(1);\n}\n\n.accueil-sticky-nav-auth {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-left: auto;\n}\n\n.accueil-sticky-nav-link--auth {\n  font-weight: 700;\n  color: #f97316;\n}\n\n.accueil-sticky-nav-link--auth:hover {\n  color: #fb923c;\n}\n\n.accueil-sticky-nav-separator {\n  color: #9ca3af;\n  font-size: 1rem;\n}\n\n/* Hamburger button — hidden on desktop */\n.accueil-sticky-nav-hamburger {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.accueil-sticky-nav-hamburger span {\n  display: block;\n  width: 24px;\n  height: 2px;\n  background: #cdd0d0;\n  border-radius: 2px;\n  transition:\n    transform 0.25s ease,\n    opacity 0.2s ease,\n    background 0.15s;\n  transform-origin: center;\n}\n\n.accueil-sticky-nav-hamburger:hover span {\n  background: #ffffff;\n}\n\n/* État ouvert → icône X */\n.accueil-sticky-nav-hamburger--open span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n.accueil-sticky-nav-hamburger--open span:nth-child(2) {\n  opacity: 0;\n  transform: scaleX(0);\n}\n.accueil-sticky-nav-hamburger--open span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* Mobile dropdown menu */\n.accueil-sticky-nav-mobile-menu {\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  background: #3f3f3f;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.32);\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0;\n  z-index: 999;\n}\n\n.accueil-sticky-nav-mobile-menu .accueil-sticky-nav-link {\n  font-size: 1.3rem;\n  padding: 1rem 1.5rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  white-space: normal;\n}\n\n.accueil-sticky-nav-mobile-auth {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 1rem 1.5rem;\n}\n\n.accueil-sticky-nav-mobile-auth .accueil-sticky-nav-link {\n  border-bottom: none;\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .accueil-sticky-nav {\n    padding: 0 1.5rem;\n  }\n\n  .accueil-sticky-nav-links {\n    display: none;\n  }\n\n  .accueil-sticky-nav-auth {\n    display: none;\n  }\n\n  .accueil-sticky-nav-hamburger {\n    display: flex;\n  }\n}\n\n.accueil-hero-section {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.accueil-hero-section::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.15) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  pointer-events: none;\n}\n\n.accueil-hero-nav {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 2.5rem;\n  padding: 2.5rem 3rem;\n}\n\n.accueil-hero-nav-link {\n  color: #ffffff;\n  font-size: 1.4rem;\n  font-weight: 500;\n  cursor: pointer;\n  letter-spacing: 0.02em;\n  transition: opacity 0.15s;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.accueil-hero-nav-link:hover {\n  opacity: 0.8;\n}\n\n.accueil-hero-bottom {\n  position: relative;\n  z-index: 1;\n  padding: 0 3rem 4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n.accueil-hero-logo {\n  height: 100px;\n  width: auto;\n}\n\n.accueil-hero-tagline {\n  color: #ffffff;\n  font-size: 1.8rem;\n  font-weight: 800;\n  margin: 0 0 2rem;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n  max-width: 800px;\n  line-height: 1.5;\n}\n\n.accueil-page {\n  width: 100%;\n  min-height: 100vh;\n  background-color: #eaeff5;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 3rem;\n}\n\n/* --- Avantages Banner (orange fullscreen) --- */\n.accueil-avantages-banner {\n  width: 100%;\n  background-color: #f97316;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0;\n  padding: 3.5rem 8rem;\n}\n\n.accueil-avantage-banner-item {\n  flex: 1 1 200px;\n  max-width: 260px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1.2rem 1.5rem;\n  color: #ffffff;\n  justify-content: flex-start;\n}\n\n.accueil-avantage-banner-icon {\n  width: 72px;\n  height: 72px;\n  object-fit: contain;\n  display: block;\n}\n\n.accueil-avantage-banner-icon-wrap {\n  width: 72px;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.2rem;\n}\n\n.accueil-avantage-banner-icon--small {\n  width: 62px;\n  height: 62px;\n}\n\n.accueil-avantage-banner-item h4 {\n  font-size: 1.1rem !important;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  margin: 0 0 0.5rem;\n  color: #ffffff;\n  text-transform: uppercase;\n}\n\n.accueil-avantage-banner-item p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n@media (max-width: 1024px) {\n  .accueil-avantages-banner {\n    padding: 2.5rem 4rem;\n  }\n  .accueil-avantage-banner-item {\n    flex: 1 1 160px;\n    max-width: 200px;\n  }\n  .accueil-avantage-banner-item h4 {\n    font-size: 1.15rem;\n  }\n  .accueil-avantage-banner-item p {\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .accueil-avantages-banner {\n    padding: 4rem 1.5rem;\n    gap: 0.75rem;\n    justify-content: center;\n  }\n  .accueil-avantage-banner-item {\n    flex: 0 0 calc(50% - 0.75rem);\n    max-width: calc(50% - 0.75rem);\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .accueil-hero-nav {\n    padding: 2rem 1.5rem;\n    gap: 1.5rem;\n  }\n  .accueil-hero-nav-link {\n    font-size: 1.2rem;\n  }\n  .accueil-hero-logo {\n    height: 70px;\n  }\n  .accueil-hero-tagline {\n    font-size: 1.2rem;\n  }\n  .accueil-hero-bottom {\n    padding: 0 1.5rem 3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .accueil-avantages-banner {\n    padding: 3.5rem 1rem;\n    gap: 0.5rem;\n  }\n  .accueil-avantage-banner-item {\n    flex: 0 0 calc(50% - 0.5rem);\n    max-width: calc(50% - 0.5rem);\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    padding: 0.75rem 0.5rem;\n  }\n  .accueil-avantage-banner-icon {\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    margin-bottom: 0.6rem;\n  }\n  .accueil-avantage-banner-item h4 {\n    font-size: 1.25rem;\n    margin-bottom: 0.3rem;\n  }\n  .accueil-avantage-banner-item p {\n    font-size: 1.15rem;\n  }\n}\n\n/* --- Header / Hero --- */\n.accueil-header {\n  background-color: #ffffff;\n  text-align: center;\n  padding: 48px 40px 5rem;\n  width: 100%;\n}\n\n.accueil-title {\n  /* font-family: Georgia, \"Times New Roman\", Times, serif; */\n  font-size: 3.5rem;\n  font-weight: 800;\n  color: #1a1a1a;\n  line-height: 1.3;\n  margin: 0 0 22px;\n}\n\n.accueil-subtitle {\n  font-size: 1.5rem;\n  color: #666666;\n  margin: 3px 0;\n  /* line-height: 1.5; */\n  font-weight: 400;\n}\n\n/* --- Section Qui sommes-nous --- */\n.accueil-about {\n  display: flex;\n  align-items: stretch;\n  /* padding: 36px 60px 60px; */\n  max-width: 1280px;\n  margin: 0 auto;\n  /* width: 90%; */\n  flex: 1;\n  background-color: #fff;\n}\n\n.accueil-about-image {\n  flex: 0 0 35%;\n  overflow: hidden;\n}\n\n.accueil-about-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n.accueil-about-text {\n  flex: 1;\n  padding: 4rem 5rem;\n}\n\n.accueil-about-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 20px;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.accueil-qui {\n  color: #f97316;\n  font-weight: 800;\n}\n\n.accueil-about-text p:first-of-type {\n  margin-top: 4rem;\n}\n\n.accueil-about-text p {\n  font-size: 1.5rem;\n  color: #374151;\n  line-height: 1.8;\n  margin: 0 0 16px;\n  text-align: justify;\n}\n\n.accueil-about-text p strong {\n  font-weight: 700;\n}\n\n.accueil-link {\n  color: #f97316;\n  cursor: pointer;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.accueil-link:hover {\n  text-decoration: underline;\n}\n\n/* --- Section Mutualisation --- */\n.accueil-mutualisation {\n  background-color: #2c3948;\n  display: flex;\n  align-items: stretch;\n}\n\n.accueil-mutualisation-content {\n  flex: 1;\n  padding: 40px 48px;\n  color: #ffffff;\n}\n\n.accueil-mutualisation-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 20px;\n  line-height: 1.3;\n  text-align: center;\n}\n\n.accueil-mutualisation-title strong {\n  font-weight: 700;\n}\n\n.accueil-mutualisation-quote {\n  font-size: 1.4rem;\n  font-style: italic;\n  color: #fff;\n  line-height: 1.7;\n  margin: 0;\n  font-weight: 600;\n  text-align: justify;\n}\n\n.accueil-mutualisation-image {\n  flex: 0 0 50%;\n  overflow: hidden;\n}\n\n.accueil-mutualisation-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n/* --- Section Avantages --- */\n.accueil-avantages {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 40px 48px;\n  background-color: #ffffff;\n  border-top: 1px solid #e5e7eb;\n}\n\n.accueil-highlight {\n  color: #f97316;\n  font-weight: 800 !important;\n}\n\n.accueil-section-block {\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 90%;\n}\n\n.accueil-section-block:last-of-type {\n  margin-bottom: 5rem;\n}\n\n.accueil-avantage {\n  flex: 1;\n  text-align: center;\n  padding: 0 8px;\n}\n\n.accueil-avantage-icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 14px;\n}\n\n.accueil-avantage-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.accueil-avantage-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #f97316;\n  text-transform: uppercase;\n  margin: 0 0 8px;\n  letter-spacing: 0.3px;\n}\n\n.accueil-avantage p {\n  font-size: 1.35rem;\n  color: #6b7280;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* --- Section Catalogue --- */\n.accueil-catalogue {\n  background-color: #fff;\n}\n\n.accueil-catalogue-top {\n  display: flex;\n  align-items: stretch;\n}\n\n.accueil-catalogue-image {\n  flex: 0 0 20%;\n  overflow: hidden;\n}\n\n.accueil-catalogue-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n.accueil-catalogue-lots {\n  flex: 1;\n  padding: 40px 48px;\n  color: #ffffff;\n}\n\n.accueil-catalogue-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 28px;\n  line-height: 1.3;\n  text-align: center;\n}\n\n.accueil-lots-grid {\n  display: flex;\n  gap: 40px;\n  margin-top: 4rem;\n}\n\n.accueil-lots-col {\n  flex: 1;\n}\n\n.accueil-lots-col p {\n  font-size: 1.35rem;\n  color: #2c3948;\n  margin: 0 0 6px;\n  line-height: 1.5;\n}\n\n/* --- Section Catalogues Description --- */\n.accueil-catalogues-desc {\n  padding: 5rem 0 0;\n  background-color: #ffffff;\n}\n\n.accueil-catalogues-desc p {\n  font-size: 1.45rem;\n  color: #374151;\n  line-height: 1.7;\n  margin: 0 0 18px;\n}\n\n.accueil-catalogues-desc p strong {\n  font-weight: 700;\n  /* text-decoration: underline; */\n}\n\n/* --- Section Entreprises performantes --- */\n.accueil-entreprises {\n  display: flex;\n  align-items: stretch;\n  background-color: #f97316;\n}\n\n.accueil-entreprises-content {\n  flex: 1;\n  padding: 40px 48px;\n  color: #ffffff;\n}\n\n.accueil-entreprises-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 18px;\n  line-height: 1.3;\n  text-align: center;\n}\n\n.accueil-entreprises-title strong {\n  font-weight: 800;\n}\n\n.accueil-entreprises-content p {\n  font-size: 1.45rem;\n  color: #ffffff;\n  line-height: 1.7;\n  margin: 0 0 14px;\n}\n\n.accueil-entreprises-note {\n  font-size: 1.5rem !important;\n  font-style: italic;\n  opacity: 0.9;\n}\n\n.accueil-entreprises-image {\n  flex: 0 0 40%;\n  overflow: hidden;\n}\n\n.accueil-entreprises-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n/* --- Section Fonctionnement simple --- */\n.accueil-fonctionnement {\n  /* padding: 48px 48px 0; */\n  background-color: #ffffff;\n  display: flex;\n}\n\n.accueil-fonctionnement-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #f97316;\n  text-align: center;\n  margin: 0 0 3rem;\n}\n\n.accueil-fonctionnement-title em {\n  /* font-style: italic; */\n  font-weight: 800;\n}\n\n.accueil-fonctionnement-row {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 5rem;\n}\n\n.accueil-fonctionnement-grid {\n  flex: 1;\n  display: flex;\n  border: 1px solid #e5e7eb;\n}\n\n.accueil-fonctionnement-col {\n  flex: 1;\n  border-right: 1px solid #e5e7eb;\n}\n\n.accueil-fonctionnement-col:last-child {\n  border-right: none;\n}\n\n.accueil-fonctionnement-header {\n  background-color: #f97316;\n  padding: 14px 16px;\n  text-align: center;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.accueil-fonctionnement-num {\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 2px;\n}\n\n.accueil-fonctionnement-label {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.accueil-fonctionnement-body {\n  padding: 16px;\n}\n\n.accueil-fonctionnement-body p {\n  font-size: 1.35rem;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0 0 12px;\n}\n\n.accueil-fonctionnement-body p strong {\n  font-weight: 800;\n}\n\n.accueil-fonctionnement-image {\n  flex: 0 0 20%;\n  overflow: hidden;\n}\n\n.accueil-fonctionnement-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n/* --- Section Délai d'exécution --- */\n.accueil-delai {\n  display: flex;\n  align-items: stretch;\n  background-color: #484848;\n}\n\n.accueil-delai-image {\n  flex: 0 0 30%;\n  overflow: hidden;\n}\n\n.accueil-delai-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n.accueil-delai-content {\n  flex: 1;\n  padding: 40px 48px;\n  text-align: center;\n  color: #ffffff;\n}\n\n.accueil-delai-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 20px;\n}\n\n.accueil-delai-title em {\n  font-weight: 800;\n}\n\n.accueil-delai-formula {\n  font-size: 1.35rem;\n  line-height: 1.6;\n  margin: 0 0 20px;\n}\n\n.accueil-delai-example {\n  font-size: 1.4rem;\n  margin: 0 0 8px;\n}\n\n.accueil-delai-result {\n  font-size: 2rem;\n  font-weight: 800;\n  margin: 0 0 20px;\n}\n\n.accueil-delai-note {\n  font-size: 1.35rem;\n  font-style: italic;\n  opacity: 0.9;\n}\n\n/* --- Section Gratuit et sans engagement --- */\n.accueil-gratuit {\n  display: flex;\n  align-items: stretch;\n}\n\n.accueil-gratuit-image {\n  flex: 0 0 20%;\n  overflow: hidden;\n}\n\n.accueil-gratuit-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  background-color: #d1d5db;\n}\n\n.accueil-gratuit-content {\n  flex: 1;\n  padding: 40px 48px;\n  background-color: #f97316;\n  color: #ffffff;\n}\n\n.accueil-gratuit-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 6px;\n  text-align: center;\n}\n\n.accueil-gratuit-title strong {\n  font-weight: 700;\n}\n\n.accueil-gratuit-price {\n  font-size: 3.5rem;\n  font-weight: 700;\n  text-align: center;\n  margin: 0 0 2.5rem;\n}\n\n.accueil-gratuit-content p {\n  /* font-size: 14px; */\n  color: #ffffff;\n  line-height: 1.7;\n  margin: 0 0 14px;\n}\n\n.accueil-gratuit-content p strong {\n  font-weight: 700;\n  /* text-decoration: underline; */\n}\n\n.accueil-gratuit-options {\n  display: flex;\n  /* gap: 16px; */\n  margin-top: 20px;\n  border: 2px solid #ffffff;\n}\n\n.accueil-gratuit-option {\n  flex: 1;\n}\n\n.accueil-gratuit-option:not(:last-child) {\n  border-right: 2px solid #ffffff;\n}\n\n.accueil-gratuit-option-header {\n  background-color: #484848;\n  color: #ffffff;\n  font-size: 2rem;\n  font-weight: 800;\n  text-align: center;\n  padding: 12px 16px;\n  line-height: 1.4;\n  border-bottom: 2px solid #ffffff;\n}\n\n.accueil-gratuit-option-body {\n  padding: 16px;\n}\n\n.accueil-gratuit-option-body p {\n  font-size: 1.35rem;\n  /* font-style: italic; */\n  line-height: 1.6;\n  margin: 0 0 10px;\n}\n\n/* --- Section On parle de nous --- */\n.accueil-presse {\n  padding: 48px 60px;\n  background-color: #ffffff;\n}\n\n.accueil-presse-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #f97316;\n  text-align: center;\n  margin: 0 0 36px;\n}\n\n.accueil-presse-title strong {\n  font-weight: 700;\n  color: #f97316;\n}\n\n.accueil-presse-list {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.accueil-presse-item {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding: 20px 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.accueil-presse-item:last-child {\n  border-bottom: none;\n}\n\n.accueil-presse-logo {\n  flex: 0 0 120px;\n}\n\n.accueil-presse-logo img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  background-color: #e5e7eb;\n  min-height: 40px;\n}\n\n.accueil-presse-text p {\n  font-size: 1.45rem;\n  color: #374151;\n  margin: 0 0 4px;\n  line-height: 1.5;\n}\n\n/* --- Responsive --- */\n@media (max-width: 960px) {\n  .accueil-about {\n    flex-direction: column;\n    padding: 24px 24px 40px;\n  }\n\n  .accueil-about-image {\n    flex: none;\n    width: 100%;\n  }\n\n  .accueil-about-image img {\n    height: 260px;\n  }\n\n  .accueil-header {\n    padding: 32px 20px 28px;\n  }\n\n  .accueil-title {\n    font-size: 2rem;\n  }\n\n  .accueil-mutualisation {\n    flex-direction: column;\n  }\n\n  .accueil-mutualisation-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-avantages {\n    flex-wrap: wrap;\n    gap: 24px;\n    padding: 32px 24px;\n  }\n\n  .accueil-avantage {\n    flex: 0 0 calc(50% - 12px);\n  }\n\n  .accueil-catalogue-top {\n    flex-direction: column;\n  }\n\n  .accueil-catalogue-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-lots-grid {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .accueil-catalogues-desc {\n    padding: 24px 24px;\n  }\n\n  .accueil-entreprises {\n    flex-direction: column;\n  }\n\n  .accueil-entreprises-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-fonctionnement {\n    padding: 32px 16px 0;\n  }\n\n  .accueil-fonctionnement-row {\n    flex-direction: column;\n  }\n\n  .accueil-fonctionnement-grid {\n    flex-direction: column;\n  }\n\n  .accueil-fonctionnement-col {\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .accueil-fonctionnement-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-delai {\n    flex-direction: column;\n  }\n\n  .accueil-delai-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-gratuit {\n    flex-direction: column;\n  }\n\n  .accueil-gratuit-image {\n    flex: none;\n    height: 200px;\n  }\n\n  .accueil-gratuit-options {\n    flex-direction: column;\n  }\n\n  .accueil-presse {\n    padding: 32px 24px;\n  }\n\n  .accueil-presse-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n}\n\n/* ==============================\n   Bannière acheteurs (logos + compteur)\n   ============================== */\n\n.accueil-acheteurs-banner {\n  background: #ffffff;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 7rem 8rem;\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n  overflow: hidden;\n}\n\n@keyframes accueil-logos-scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.accueil-acheteurs-logos {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.accueil-logos-track {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 2.5rem;\n  width: max-content;\n  animation: accueil-logos-scroll 50s linear infinite;\n}\n\n#section-acheteurs .accueil-logos-track {\n  animation-duration: 70s;\n}\n\n.accueil-acheteur-logo-placeholder {\n  aspect-ratio: 3 / 2;\n  min-width: 110px;\n  height: 76px;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  padding: 0 0.3rem;\n  word-break: break-word;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.accueil-acheteur-logo-placeholder:hover {\n  background: transparent;\n}\n\n.accueil-prestataire-logo-img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  display: block;\n  /* Anti pop-in : opacite 0 par defaut, fade-in declenche au CHARGEMENT reel de\n     l'image (classe .is-loaded posee par onLoad). L'espace est deja reserve par\n     .accueil-acheteur-logo-placeholder, donc aucun layout shift. */\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.accueil-prestataire-logo-img.is-loaded {\n  opacity: 1;\n}\n\n.accueil-prestataire-logo-fallback {\n  display: none;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  padding: 0 0.3rem;\n  word-break: break-word;\n  color: #9ca3af;\n}\n\n.accueil-acheteurs-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.6rem;\n}\n\n.accueil-acheteurs-number {\n  font-size: 4rem;\n  font-weight: 800;\n  color: #f97316;\n  line-height: 1;\n}\n\n.accueil-acheteurs-label {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  line-height: 1;\n}\n\n.accueil-acheteurs-link {\n  font-size: 1.1rem !important;\n  font-weight: 700;\n}\n\n@media (max-width: 900px) {\n  .accueil-acheteurs-logos {\n    overflow: hidden;\n  }\n  .accueil-logos-track {\n    animation-duration: 35s;\n  }\n  #section-acheteurs .accueil-logos-track {\n    animation-duration: 50s;\n  }\n  .accueil-acheteur-logo-placeholder {\n    flex: none;\n    min-width: 90px;\n    height: 65px;\n    aspect-ratio: 3 / 2;\n    font-size: 0.8rem;\n  }\n  .accueil-acheteurs-info {\n    flex: none;\n    width: 100%;\n    align-items: center;\n    margin-top: 2rem;\n  }\n  .accueil-acheteurs-banner {\n    flex-direction: column;\n    padding: 4rem 1.5rem;\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .accueil-acheteurs-logos {\n    overflow: hidden;\n  }\n  .accueil-logos-track {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    width: max-content;\n    gap: 1.5rem;\n    animation: accueil-logos-scroll 30s linear infinite;\n  }\n  #section-acheteurs .accueil-logos-track {\n    animation-duration: 40s;\n  }\n  .accueil-acheteur-logo-placeholder {\n    min-width: 80px;\n    height: 55px;\n    width: auto;\n    flex-shrink: 0;\n    aspect-ratio: 3 / 2;\n  }\n  #section-acheteurs .accueil-logos-track > *:nth-child(n + 23) {\n    display: flex;\n  }\n  #section-prestataires .accueil-logos-track > *:nth-child(n + 16) {\n    display: flex;\n  }\n}\n\n@media (max-width: 480px) {\n  .accueil-acheteurs-logos {\n    gap: 0.4rem;\n  }\n}\n\n/* ==============================\n   Section fonctionnement acheteurs\n   ============================== */\n\n.accueil-fonctact-section {\n  background: #f3f4f6;\n  display: flex;\n  align-items: stretch;\n}\n\n.accueil-fonctact-text {\n  flex: 1;\n  padding: 7rem 6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  max-height: 520px;\n  overflow-y: auto;\n}\n\n.accueil-fonctact-title {\n  font-size: 2.8rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 0.5rem;\n  line-height: 1.25;\n}\n\n.accueil-fonctact-text p {\n  font-size: 1.2rem;\n  color: #1f2937;\n  line-height: 1.8;\n  margin: 0;\n}\n\n.accueil-fonctact-text p strong {\n  font-weight: 700;\n}\n\n.accueil-voir-suite {\n  align-self: flex-start;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #f97316;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  transition: opacity 0.15s;\n}\n\n.accueil-voir-suite--reduire {\n  margin-top: 0.25rem;\n}\n\n.accueil-voir-suite:hover {\n  opacity: 0.75;\n}\n\n.accueil-fonctact-steps {\n  margin: 0;\n  padding-left: 1.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.accueil-fonctact-steps li {\n  font-size: 1.2rem;\n  color: #1f2937;\n  line-height: 1.75;\n}\n\n.accueil-fonctact-steps li strong {\n  font-weight: 700;\n  color: #111827;\n}\n\n.accueil-fonctact-cta {\n  margin-top: 0.5rem;\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.accueil-fonctact-image {\n  flex: 0 0 50%;\n  overflow: hidden;\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n  height: 520px;\n}\n\n.accueil-fonctact-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n@media (max-width: 960px) {\n  .accueil-fonctact-section {\n    flex-direction: column;\n  }\n  .accueil-fonctact-image {\n    flex: none;\n    height: 280px;\n    order: -1;\n    position: static;\n    align-self: auto;\n  }\n  .accueil-fonctact-text {\n    padding: 4rem 2rem;\n    max-height: none;\n    overflow-y: visible;\n  }\n  .accueil-fonctact-section--reversed .accueil-fonctact-text {\n    padding: 4rem 2rem;\n  }\n}\n\n/* Variante prestataires : image à gauche */\n.accueil-fonctact-section--reversed .accueil-fonctact-text {\n  padding: 4rem 6rem 4rem 4rem;\n}\n\n@media (max-width: 960px) {\n  .accueil-fonctact-section--reversed .accueil-fonctact-image {\n    order: -1;\n  }\n}\n\n/* ==============================\n   Mosaïque des lots techniques\n   ============================== */\n\n.accueil-lots-mosaic-section {\n  background: #f9fafb;\n  padding: 7rem 8rem;\n}\n\n.accueil-lots-mosaic-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.accueil-lots-mosaic-header h2 {\n  font-size: 2.5rem;\n  color: #f97316;\n  margin-bottom: 0.5rem;\n}\n\n.accueil-lots-mosaic-header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n.accueil-lots-mosaic {\n  display: grid;\n  /* Toujours 4 colonnes, mais qui occupent toute la largeur utile : on retire le plafond\n     `max-width: 1400px; margin: 0 auto` qui centrait la grille et laissait de grosses marges sur\n     grand ecran. Les cartes s'elargissent pour remplir la place ; leur ratio 4/3 preserve la hauteur. */\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.accueil-lot-card {\n  display: flex;\n  flex-direction: column;\n  aspect-ratio: 4 / 3;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s;\n}\n\n.accueil-lot-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\n}\n\n.accueil-lot-card:hover .accueil-lot-card-body {\n  background: #f97316;\n}\n\n.accueil-lot-card:hover .accueil-lot-card-code,\n.accueil-lot-card:hover .accueil-lot-card-nom {\n  color: #ffffff;\n}\n\n.accueil-lot-card:focus {\n  outline: 3px solid #f97316;\n  outline-offset: 2px;\n}\n\n.accueil-lot-card-img-wrap {\n  flex: 3;\n  min-height: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.accueil-lot-card-badge {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  padding: 0.3rem 0.7rem;\n  border-radius: 20px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: white;\n  z-index: 2;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.accueil-lot-card-badge--ingenierie {\n  background-color: #6b7280;\n}\n.accueil-lot-card-badge--travaux {\n  background-color: #f97316;\n}\n.accueil-lot-card-badge--services {\n  background-color: #6b7280;\n}\n\n.accueil-lot-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.accueil-lot-card-body {\n  flex: 1;\n  min-height: 0;\n  padding: 0.55rem 0.9rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 0.15rem;\n  background: #ffffff;\n  border-top: 1px solid #f3f4f6;\n  transition: background 0.2s;\n}\n\n.accueil-lot-card-code {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1f2937;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.accueil-lot-card-nom {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n/* Skeleton de chargement des lots (evite le flash \"4 puis le reste\") */\n\n.accueil-lot-card--skeleton {\n  cursor: default;\n  pointer-events: none;\n}\n\n.accueil-skeleton-shimmer,\n.accueil-skeleton-line {\n  background: linear-gradient(\n    90deg,\n    #eceff1 25%,\n    #f5f7f8 37%,\n    #eceff1 63%\n  );\n  background-size: 400% 100%;\n  animation: accueil-skeleton-pulse 1.4s ease infinite;\n}\n\n.accueil-skeleton-shimmer {\n  width: 100%;\n  height: 100%;\n}\n\n.accueil-skeleton-line {\n  display: block;\n  border-radius: 4px;\n  height: 0.8rem;\n}\n\n.accueil-skeleton-line--code {\n  width: 30%;\n  height: 0.7rem;\n}\n\n.accueil-skeleton-line--nom {\n  width: 70%;\n}\n\n@keyframes accueil-skeleton-pulse {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n/* Articles dans la modale lot */\n\n.accueil-lot-articles {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n}\n\n.accueil-lot-articles .modal-articles-search {\n  padding: 1rem 2rem 1rem;\n  flex-shrink: 0;\n}\n\n.accueil-lot-articles .modal-articles-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.accueil-lot-articles .article-row--public {\n  grid-template-columns: 90px 1fr;\n}\n\n/* Prompt connexion — overlay centré identique à Annuaire */\n.accueil-article-prompt-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n  padding: 1rem;\n}\n\n.accueil-article-prompt-card {\n  position: relative;\n  background: #fff;\n  border-radius: 16px;\n  padding: 2.5rem 2rem 2rem;\n  max-width: 420px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n}\n\n.accueil-article-prompt-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1rem;\n  color: #9ca3af;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0.2rem 0.4rem;\n}\n\n.accueil-article-prompt-close:hover {\n  color: #374151;\n}\n\n.accueil-article-prompt-title {\n  font-size: 1.65rem;\n  font-weight: 700;\n  color: #f97316;\n  margin-bottom: 0.85rem;\n}\n\n.accueil-article-prompt-text {\n  font-size: 1.2rem;\n  color: #6b7280;\n  line-height: 1.65;\n  margin-bottom: 1.75rem;\n}\n\n.accueil-article-prompt-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Responsive mosaïque */\n\n@media (max-width: 1200px) {\n  .accueil-lots-mosaic {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .accueil-lots-mosaic {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n\n  .accueil-lots-mosaic-header h2 {\n    font-size: 2.5rem;\n  }\n\n  .accueil-lots-mosaic-section {\n    padding: 5rem 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .accueil-lots-mosaic {\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n\n  .accueil-lots-mosaic-section {\n    padding: 4rem 0.75rem;\n  }\n}\n\n/* ==============================\n   Section Témoignages\n   ============================== */\n\n.accueil-temoignages-section {\n  background: #ffffff;\n  padding: 7rem 8rem;\n}\n\n.accueil-temoignages-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.accueil-temoignages-header h2 {\n  font-size: 2.5rem;\n  color: #f97316;\n  font-weight: 700;\n}\n\n/* Testimonials: grid responsive */\n.accueil-temoignages-grid-wrapper {\n  width: 100%;\n}\n\n.accueil-temoignages-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1.5rem;\n  width: 100%;\n}\n\n.accueil-temoignage-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accueil-temoignage-quote-icon {\n  font-size: 3.5rem;\n  color: #f97316;\n  line-height: 1;\n  font-family: Georgia, serif;\n  font-weight: 700;\n}\n\n.accueil-temoignage-text {\n  font-size: 1.1rem;\n  color: #4b5563;\n  line-height: 1.7;\n  font-style: italic;\n  flex: 1;\n}\n\n.accueil-temoignage-author {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #374151;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 0.75rem;\n}\n\n@media (max-width: 960px) {\n  .accueil-temoignages-section {\n    padding: 5rem 3rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .accueil-temoignages-section {\n    padding: 4rem 1.5rem;\n  }\n\n  .accueil-temoignages-grid-wrapper {\n    overflow-x: unset;\n  }\n\n  .accueil-temoignages-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .accueil-temoignage-card {\n    min-width: unset;\n  }\n\n  .accueil-avantages {\n    flex-direction: column;\n    padding: 2.5rem 1.5rem;\n    gap: 2rem;\n  }\n\n  .accueil-avantage-title {\n    font-size: 1.4rem;\n  }\n\n  .accueil-avantage p {\n    font-size: 1.25rem;\n  }\n}\n\n/* ==============================\n   Section Qui sommes-nous\n   ============================== */\n\n.accueil-quisommes-section {\n  background: #ffffff;\n  display: flex;\n  align-items: stretch;\n  padding: 0;\n}\n\n.accueil-quisommes-image {\n  flex: 0 0 45%;\n  overflow: hidden;\n}\n\n.accueil-quisommes-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.accueil-quisommes-text {\n  flex: 1;\n  padding: 7rem 6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n  justify-content: center;\n  background: #f3f4f6;\n}\n\n.accueil-quisommes-title {\n  font-size: 2.8rem;\n  font-weight: 700;\n  color: #f97316;\n  margin: 0 0 0.5rem;\n  line-height: 1.25;\n}\n\n.accueil-quisommes-text p {\n  font-size: 1.1rem;\n  color: #374151;\n  line-height: 1.8;\n  margin: 0;\n}\n\n.accueil-quisommes-cta {\n  margin-top: 0.5rem;\n}\n\n@media (max-width: 960px) {\n  .accueil-quisommes-section {\n    flex-direction: column;\n  }\n\n  .accueil-quisommes-image {\n    flex: none;\n    height: 300px;\n  }\n\n  .accueil-quisommes-text {\n    padding: 4rem 2rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .accueil-quisommes-title {\n    font-size: 2.8rem;\n  }\n  .accueil-quisommes-text p {\n    font-size: 1.45rem;\n  }\n}\n\n/* ==============================\n   Modale vidéo YouTube\n   ============================== */\n\n.accueil-video-wrapper {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n}\n\n.accueil-video-wrapper iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n.accueil-modal--page-content {\n  width: 90vw;\n  max-width: 960px;\n  height: 85dvh;\n}\n\n/* ==============================\n   Section Presse\n   ============================== */\n\n.accueil-presse-section {\n  background: #ffffff;\n  padding: 7rem 8rem;\n}\n\n.accueil-presse-section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #f97316;\n  text-align: center;\n  margin: 0 0 3rem;\n}\n\n.accueil-presse-section-title strong {\n  font-weight: 700;\n}\n\n.accueil-presse-section-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  max-width: 900px;\n  margin: 0 auto;\n  gap: 2rem;\n}\n\n.accueil-presse-section-card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition:\n    box-shadow 0.2s,\n    transform 0.2s;\n}\n\n.accueil-presse-section-card:hover {\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);\n  transform: translateY(-2px);\n}\n\n.accueil-presse-section-logo-wrap {\n  height: 140px;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n}\n\n.accueil-presse-section-logo-wrap img {\n  max-width: 100%;\n  max-height: 80px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.accueil-presse-section-body {\n  padding: 1.25rem 1.5rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 0.75rem;\n  background: #f3f4f6;\n}\n\n.accueil-presse-section-body p {\n  font-size: 1.15rem;\n  color: #374151;\n  line-height: 1.6;\n  font-style: italic;\n  margin: 0;\n  flex: 1;\n}\n\n.accueil-presse-section-body a {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #f97316;\n  text-decoration: none;\n}\n\n.accueil-presse-section-body a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .accueil-presse-section {\n    padding: 5rem 2rem;\n  }\n\n  .accueil-presse-section-list {\n    grid-template-columns: 1fr;\n    max-width: 320px;\n  }\n}\n\n@media (max-width: 480px) {\n  .accueil-presse-section {\n    padding: 4rem 1.5rem;\n  }\n}\n\n/* ==============================\n   Footer\n   ============================== */\n\n.accueil-footer {\n  background-color: #2c3948;\n  padding: 3rem 8rem 2.5rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 3rem;\n}\n\n.accueil-footer-left {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.accueil-footer-logo {\n  height: 44px;\n  width: auto;\n  display: block;\n  opacity: 0.9;\n  margin-left: -2px;\n}\n\n.accueil-footer-links {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0.5rem 2rem;\n  margin-top: 1rem;\n}\n\n.accueil-footer-links-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 2rem;\n  align-items: center;\n}\n\n.accueil-footer-link {\n  color: #94a3b8;\n  font-size: 1.35rem;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color 0.15s;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.accueil-footer-btn {\n  align-self: center;\n}\n\n.accueil-footer-link:hover {\n  color: #ffffff;\n}\n\n@media (max-width: 960px) {\n  .accueil-footer {\n    padding: 2.5rem 3rem 2rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .accueil-footer {\n    padding: 2rem 1.5rem 1.75rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1.75rem;\n  }\n\n  .accueil-footer-logo {\n    height: 36px;\n  }\n\n  .accueil-footer-left {\n    gap: 1.25rem;\n  }\n\n  .accueil-footer-links {\n    gap: 0.5rem 1.5rem;\n  }\n\n  .accueil-footer-links-row {\n    display: contents;\n  }\n\n  .accueil-footer-link {\n    font-size: 1.1rem;\n  }\n\n  .accueil-footer-btn {\n    align-self: flex-start !important;\n    margin-right: auto;\n  }\n}\n\n/* ==============================\n   Upscale typographie — grand écran\n   ============================== */\n\n@media (min-width: 1024px) {\n  /* Navigation */\n  .accueil-sticky-nav-link {\n    font-size: 1.35rem;\n  }\n\n  /* Hero */\n  .accueil-title {\n    font-size: 4.2rem;\n  }\n  .accueil-subtitle {\n    font-size: 1.8rem;\n  }\n\n  /* À propos (section haut de page) */\n  .accueil-about-title {\n    font-size: 4.2rem;\n  }\n  .accueil-about-text p {\n    font-size: 1.75rem;\n  }\n\n  /* Mutualisation */\n  .accueil-mutualisation-title {\n    font-size: 3.6rem;\n  }\n  .accueil-mutualisation-quote {\n    font-size: 1.65rem;\n  }\n\n  /* Avantages */\n  .accueil-avantage-title {\n    font-size: 1.55rem;\n  }\n  .accueil-avantage p {\n    font-size: 1.6rem;\n  }\n\n  /* Fonctionnement simple (tableau) */\n  .accueil-fonctionnement-title {\n    font-size: 2.5rem;\n  }\n  .accueil-fonctionnement-num {\n    font-size: 18px;\n  }\n  .accueil-fonctionnement-label {\n    font-size: 18px;\n  }\n  .accueil-fonctionnement-body p {\n    font-size: 1.6rem;\n  }\n\n  /* Catalogue */\n  .accueil-catalogue-title {\n    font-size: 3.6rem;\n  }\n  .accueil-lots-col p {\n    font-size: 1.6rem;\n  }\n  .accueil-catalogues-desc p {\n    font-size: 1.75rem;\n  }\n\n  /* Entreprises performantes */\n  .accueil-entreprises-title {\n    font-size: 3.6rem;\n  }\n  .accueil-entreprises-content p {\n    font-size: 1.75rem;\n  }\n  .accueil-entreprises-note {\n    font-size: 1.8rem !important;\n  }\n\n  /* Délai d'exécution */\n  .accueil-delai-title {\n    font-size: 3.6rem;\n  }\n  .accueil-delai-formula {\n    font-size: 1.6rem;\n  }\n  .accueil-delai-example {\n    font-size: 1.65rem;\n  }\n  .accueil-delai-result {\n    font-size: 2.4rem;\n  }\n  .accueil-delai-note {\n    font-size: 1.6rem;\n  }\n\n  /* Gratuit et sans engagement */\n  .accueil-gratuit-title {\n    font-size: 3.6rem;\n  }\n  .accueil-gratuit-price {\n    font-size: 4.2rem;\n  }\n  .accueil-gratuit-option-header {\n    font-size: 2.4rem;\n  }\n  .accueil-gratuit-option-body p {\n    font-size: 1.6rem;\n  }\n\n  /* Bannière acheteurs (compteur) */\n  .accueil-acheteurs-number {\n    font-size: 5rem;\n  }\n  .accueil-acheteurs-label {\n    font-size: 1.6rem;\n  }\n  .accueil-acheteurs-link {\n    font-size: 1.3rem !important;\n  }\n\n  /* Fonctionnement acheteurs / prestataires */\n  .accueil-fonctact-title {\n    font-size: 3.4rem;\n  }\n  .accueil-fonctact-text p {\n    font-size: 1.45rem;\n  }\n  .accueil-fonctact-steps li {\n    font-size: 1.45rem;\n  }\n\n  /* Mosaïque des lots */\n  .accueil-lots-mosaic-header h2 {\n    font-size: 2.5rem;\n  }\n  .accueil-lots-mosaic-header p {\n    font-size: 1.35rem;\n  }\n  .accueil-lot-card-badge {\n    font-size: 1.25rem;\n  }\n  .accueil-lot-card-code {\n    font-size: 1.3rem;\n  }\n  .accueil-lot-card-nom {\n    font-size: 1.5rem;\n  }\n\n  /* Témoignages */\n  .accueil-temoignages-header h2 {\n    font-size: 2.5rem;\n  }\n  .accueil-temoignage-text {\n    font-size: 1.3rem;\n  }\n  .accueil-temoignage-author {\n    font-size: 1.4rem;\n  }\n\n  /* Qui sommes-nous */\n  .accueil-quisommes-title {\n    font-size: 3.4rem;\n  }\n  .accueil-quisommes-text p {\n    font-size: 1.35rem;\n  }\n\n  /* Centralis dans les médias */\n  .accueil-presse-section-title {\n    font-size: 2.5rem;\n  }\n  .accueil-presse-section-body p {\n    font-size: 1.4rem;\n  }\n  .accueil-presse-section-body a {\n    font-size: 1.3rem;\n  }\n\n  /* Bannière avantages (fond orange) */\n  .accueil-avantage-banner-item h4 {\n    font-size: 1.3rem !important;\n  }\n  .accueil-avantage-banner-item p {\n    font-size: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
